import { usePrimaryEnvironmentIsWorkspaceProxy } from "../../environments/primary";
import { readRuntimeSurfaceState } from "../../environments/runtimeSurface";

/**
 * Whether this client is a control surface for cloud runtimes rather than an
 * execution host of its own.
 *
 * Its own module because both sides of the `/new` split need the same answer and
 * the gate imports the composer, so parking it in either file would either make
 * a cycle or leave the fact defined twice. The two callers ask for different
 * reasons — the gate, to decide whether "no connections" is even an actionable
 * state; the composer, to scope its project picker — which is exactly the pair
 * that would drift if each derived it locally.
 */
export function useIsCloudControlSurface(): boolean {
  const primaryIsWorkspaceProxy = usePrimaryEnvironmentIsWorkspaceProxy();
  return primaryIsWorkspaceProxy || readRuntimeSurfaceState().surface === "cloud-official";
}
